<template>
  <label
    class="sorting__option"
    :class="[
      { 'sorting__option--selected': isSelected },
      { 'sorting__option--first': index === 0 },
      'sorting__option--' + option.code,
    ]"
    :for="'checkbox--' + option.code"
    @click="sortBy(option)"
  >
    {{ $t(`filter.sorting.${option.code}`) }}
    <input
      type="radio"
      :id="'checkbox--' + option.code"
      class="sorting__checkbox"
      :name="name"
      :checked="isSelected"
    />
  </label>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import {
  notifyExternalServices,
  ACTIONS,
} from '@/services/external-communication/external-communication'

export default {
  name: 'SortingOption',
  props: {
    name: { type: String, required: true },
    option: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  computed: {
    ...mapState('filter', ['activeSort']),

    ...mapGetters({
      isMobile: 'filter/isMobile',
    }),

    isSelected() {
      return this.activeSort.code === this.option.code
    },
  },
  methods: {
    ...mapActions({
      setSorting: 'filter/setSorting',
    }),

    sortBy(option) {
      this.setSorting(option)

      notifyExternalServices({
        action: ACTIONS.filterAndSorting,
        details: { action: 'sort', label: option.code },
      })

      this.$emit('selected')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './SortingOption';
</style>
